import { render, staticRenderFns } from "./AdminDistrictsAdd.vue?vue&type=template&id=35b3f83c&"
import script from "./AdminDistrictsAdd.vue?vue&type=script&lang=js&"
export * from "./AdminDistrictsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports